import { Component, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ProcessService } from 'src/app/modules/instance/services/process.service';
import { ITaskModel } from '../../interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'slider-for-threads',
    templateUrl: './slider-for-threads.component.html',
    styleUrls: ['./slider-for-threads.component.scss']
})
export class SliderForThreadsComponent {
    @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

    @Output() threadsCountChanged = new EventEmitter<object>();

    @Input() process!: ITaskModel;

    @Input() dark: boolean = true;

    public isChanged: boolean = false;
    public pendingMaxThreadsCount: number = 1;
    private _snapshotAvailableThreadsCount: number | null = null;

    constructor(readonly processService: ProcessService) {}

    get availableThreadsCount(): number {
        if (this._snapshotAvailableThreadsCount !== null) {
            return this._snapshotAvailableThreadsCount;
        }
        const result = this.calculateAvailableThreadsCount();
        return result;
    }

    get badgeThreadsCount(): number {
        if (this.menuTrigger?.menuOpen) {
            return this.pendingMaxThreadsCount;
        }

        return this.process?.allowedThreadsCount ?? 0;
    }

    onMenuOpened() {
        this.pendingMaxThreadsCount = this.process?.maxThreadsCount || 1;
        this._snapshotAvailableThreadsCount = this.calculateAvailableThreadsCount();
        this.isChanged = false;
    }

    private calculateAvailableThreadsCount(): number {
        return (
            (this.process?.isWorking
                ? (this.processService.availableThreadsCountValidated || 0) + (this.process?.maxThreadsCount || 0)
                : this.processService.availableThreadsCountValidated) || 1
        );
    }

    setTreadsCount() {
        if (this.isChanged) {
            this.process.maxThreadsCount = this.pendingMaxThreadsCount;
            this.threadsCountChanged.emit({
                maxThreadsCount: this.pendingMaxThreadsCount
            });
        }
        this._snapshotAvailableThreadsCount = null;
        this.menuTrigger.closeMenu();
        this.isChanged = false;
    }

    setValue(value: number) {
        if (value !== this.pendingMaxThreadsCount) {
            this.isChanged = true;
            this.pendingMaxThreadsCount = value;
        }
    }

    safeValue(value: number | null) {
        if (!value) {
            return 0;
        }
        return value;
    }

    handleThumbInput(event: Event) {
        const target = event.target as HTMLInputElement | null;
        const nextValue = target?.valueAsNumber;

        if (typeof nextValue !== 'number' || Number.isNaN(nextValue)) {
            return;
        }

        this.setValue(nextValue);
    }
}
